<template>
  <div class="empty-result-root-container">
    <div class="logo"></div>
    <p>没有筛选结果</p>
    <p>换个条件再试试</p>
    <div class="custom-made" @click="showCustomWorksPopup">
      <span>需求定制</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "isEmptyResult",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {
    showCustomWorksPopup() {
      this.$modal.show("customWorks");
    }
  },
  watch: {},
  computed: {}
};
</script>

<style scoped>
.empty-result-root-container {
  width: 108px;
  height: 226px;
  position: absolute;
  background-color: #ffffff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.logo {
  width: 108px;
  height: 137px;
  background-image: url(../../../../static/svg/template-material-lib/common/isEmpty.png);
  background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: 15px;
}

.rootContainer > p {
  color: #474261;
  font-size: 12px;
}

.custom-made {
  width: 100px;
  height: 32px;
  background-color: #5778fb;
  border-radius: 16px;
  margin-top: 14px;
  margin-left: 4px;
  padding: 5px;
}

.custom-made span {
  font-size: 12px;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/isEmptyResult.vue